/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Load_Media_LabelInputs */



/**
* | output |
* | --- |
* | "Also load this video as the project media" |
*
* @param {Subtitle_Extract_Load_Media_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_load_media_label = /** @type {((inputs?: Subtitle_Extract_Load_Media_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Load_Media_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargez également cette vidéo comme média du projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden Sie dieses Video auch als Projektmedium.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica anche questo video come file multimediale del progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Также загрузите это видео как медиафайл проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga también este vídeo como archivo multimedia del proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("同时将此视频加载为项目媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このビデオをプロジェクトメディアとして読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस वीडियो को प्रोजेक्ट मीडिया के रूप में भी लोड करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregue também este vídeo como mídia do projeto.")
	return /** @type {LocalizedString} */ ("Also load this video as the project media")
});